import React from "preact/compat";

const childrenPolygons = (styleDuration, color) => {
  return (
      <>
          <div style={{ width: '300%', height: '100%', position: 'absolute', zIndex: 1, right: '100%', top: 0}}>
              <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                  <polygon points="20 0, 80 0, 68 30, 8 30" fill={color}/>

                  <polygon points="4 45, 24 45, 20 55, 0 55" fill={color}/>

                  <polygon points="58 40, 78 40, 70 60, 50 60" fill={color}/>

                  <polygon points="100 0, 100 0, 100 100, 60 100" fill={color}/>

                  <polygon points="20 80, 56 80, 48 100, 12 100" fill={color}/>
              </svg>
          </div>
      </>
  )
}

const childrenBubble = (styleDuration, color, secondaryColor) => {
    return (
        <div className='anim-child' style={{ width: '100%', height: '100%', position: 'absolute', zIndex: 1, right: 0, top: 0, visibility: 'visible', ...styleDuration}}>
            <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="35" fill={color} strokeWidth="30%" stroke={secondaryColor} />
            </svg>
        </div>
    )
}

const dancingSquares = (styleDuration, color, secondaryColor) => {
    return (
        <div className='anim-child' style={styleDuration}>
            <div className='column-squares' style={styleDuration}>
                <div className='dancing-square' style={{backgroundColor: color + '50'}}/>
                <div className='dancing-square' style={{backgroundColor: color + '75'}}/>
                <div className='dancing-square' style={{backgroundColor: color}}/>
                <div className='dancing-square' style={{backgroundColor: color + '25'}}/>
                <div className='dancing-square' style={{backgroundColor: color + '50'}}/>
                <div className='dancing-square' style={{backgroundColor: color + '75'}}/>
                <div className='dancing-square' style={{backgroundColor: color}}/>
            </div>
            <div className='column-squares' style={styleDuration}>
                <div className='dancing-square' style={{backgroundColor: color + '25'}}/>
                <div className='dancing-square'/>
                <div className='dancing-square' style={{backgroundColor: color + '75'}}/>
                <div className='dancing-square' style={{backgroundColor: color}}/>
                <div className='dancing-square' style={{backgroundColor: color + '25'}}/>
                <div className='dancing-square'/>
                <div className='dancing-square' style={{backgroundColor: color + '75'}}/>
            </div>
            <div className='column-squares' style={styleDuration}>
                <div className='dancing-square' style={{backgroundColor: color}}/>
                <div className='dancing-square' style={{backgroundColor: color + '25'}}/>
                <div className='dancing-square' style={{backgroundColor: color + '50'}}/>
                <div className='dancing-square' style={{backgroundColor: color + '75'}}/>
                <div className='dancing-square' style={{backgroundColor: color}}/>
                <div className='dancing-square' style={{backgroundColor: color + '25'}}/>
                <div className='dancing-square' style={{backgroundColor: color + '50'}}/>
            </div>
        </div>
    )
}

const childrenSquare = (styleDuration, color, secondaryColor) => {
    return (
        <div className='anim-child' style={{...styleDuration, borderColor: color, outlineColor: secondaryColor}}/>
    )
}

export const animations = [
    {
        name: 'classic',
        classActive: 'displayed-scanning-1',
        classNext: 'hidden-scanning-1',
        children: null,
        conditionState: null
    },
    {
        name: 'square-from-top',
        classActive: 'displayed-scanning-2',
        classNext: 'hidden-scanning-2',
        children: childrenSquare,
        conditionState: 1
    },
    {
        name: 'bubble-from-top',
        classActive: 'displayed-scanning-3',
        classNext: 'hidden-scanning-3',
        children: null,
        conditionState: null
    },
    {
        name: 'polygons',
        classActive: 'displayed-scanning-4',
        classNext: 'hidden-scanning-4',
        children: childrenPolygons,
        conditionState: 1
    },
    {
        name: 'bubble-expend',
        classActive: 'displayed-scanning-5',
        classNext: 'hidden-scanning-5',
        children: childrenBubble,
        conditionState: 1
    },
    {
        name: 'bubble-expend',
        classActive: 'displayed-scanning-6',
        classNext: 'hidden-scanning-6',
        children: dancingSquares,
        conditionState: 0
    },
    {
        name: 'fade',
        classActive: 'displayed-scanning-7',
        classNext: 'hidden-scanning-7',
        children: null,
        conditionState: 0
    },
]
